import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { ITagEvent } from '../interfaces/tag-event.interface';

@Injectable({
  providedIn: 'root'
})
export class RecordEventsStorageService {

  constructor(private localStorageService: LocalStorageService) {
  }

  public clearManualEvents(): void {
    const events = this.events;

    events.forEach((event, index) => {
      if (!this.checkIsCurrentDate(event)) {
        events.splice(index, 1);
      }
    });

    this.events = events;
  }

  public updateManualEvents(event: ITagEvent): void {
    if (!event.created) {
      event.created = new Date();
    }

    const events = this.events;

    events.push(event);
    this.events = events;
  }

  public removeManualEventByActionIdAndSessionId(sid: string, sessionId: string): void {
    const events = this.events;
    const index = events.findIndex(item => item.action === sid && item.session === sessionId);

    if (index > -1) {
      events.splice(index, 1);
      this.events = events;
    }
  }

  private checkIsCurrentDate = (event: ITagEvent): boolean => {
    const currentDate = new Date();

    if (!event.created) {
      return false;
    }

    event.created = new Date(event.created);
    return event.created?.getDay() === currentDate.getDay()
      && event.created?.getFullYear() === currentDate.getFullYear()
      && event.created.getMonth() === currentDate.getMonth();
  };

  get events(): ITagEvent[] {
    return this.localStorageService.retrieve('events') ?? [];
  }

  set events(events: ITagEvent[]) {
    this.localStorageService.store('events', events);
  }
}
